import "./index.scss";

import GroupIcon from "@mui/icons-material/Group";
import { Box } from "@mui/material";
import { TMemberDetails } from "models/member";

export default function GroupSection(props: { member: TMemberDetails }) {
  const { member } = props;
  return (
    <>
      <p className="title group-section__title">Groups</p>
      <Box>
        {member?.groups.map((m, i) => (
          <Item key={`groupLabel${i}`} label={m} />
        ))}
        {member?.groups.length === 0 && <>None</>}
      </Box>
    </>
  );
}

const Item = ({ label }) => {
  return (
    <Box display="inline-flex" mr={1} mb={1} className="group-section__item">
      <GroupIcon /> <span>{label}</span>
    </Box>
  );
};
